import { render, staticRenderFns } from "./ShowOrEditDocuments.vue?vue&type=template&id=56ec9464&"
import script from "./ShowOrEditDocuments.vue?vue&type=script&lang=js&"
export * from "./ShowOrEditDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports